export const asiaStateToLocalizationKeyMap = {
  LUONNOS: "asiaStates.kj.LUONNOS",
  AVOIN: "asiaStates.kj.AVOIN",
  VALMISTELUSSA: "asiaStates.kj.VALMISTELUSSA",
  TAYDENNETTAVA: "asiaStates.kj.TAYDENNETTAVA",
  PAATETTY: "asiaStates.kj.PAATETTY",
  PASSIVOITU: "asiaStates.kj.PASSIVOITU"
};
